import { Button, Entering, Typography } from 'components';
import { CreditCard, PaymentMethodEnum } from 'gql/graphql';
import { InfoHollowIcon } from 'lib/svgs/Icons';
import { useTranslations } from 'next-intl';
import { useCreditCard } from 'providers/BillingInfoProviders/useCreditCard';
import { useClientAccount } from 'providers/ClientProviders/useClientAccount';
import { useEffect, useState } from 'react';
import CreditCardContent from './CreditCardContent';
import CreditCardForm from './CreditCardForm';

const CreditCardMain = () => {
  const t = useTranslations();

  const { data: clientAccount } = useClientAccount();
  const { data: creditCardData } = useCreditCard();

  const [state, setState] = useState({
    editing: false,
    creditCard: null as null | CreditCard
  });

  const onCancel = () => setState((oldState) => ({ ...oldState, editing: false }));
  const onClick = () => setState((oldState) => ({ ...oldState, editing: true }));

  const onUpdateCreditCard = (creditCard: CreditCard) =>
    setState((oldState) => ({ ...oldState, creditCard: creditCard, editing: false }));

  useEffect(() => {
    if (creditCardData && creditCardData?.creditCard)
      setState((oldState) => ({
        ...oldState,
        creditCard: creditCardData?.creditCard as CreditCard
      }));
  }, [creditCardData]);

  if (
    !creditCardData?.creditCard &&
    clientAccount?.paymentMethod === PaymentMethodEnum.CreditCard &&
    !state.editing
  )
    return (
      <Entering
        offset={5}
        delay={0.6}
        duration={0.2}
        position="bottom"
        className="flex h-fit w-[37.5%] justify-between rounded-md bg-white p-4 shadow-custom"
      >
        <div className="flex">
          <Typography variant="medium1" className={'!m-0 !leading-10 text-tertiary-100'}>
            {t('billings.show.credit_card')}
          </Typography>
          <a className="hidden"></a>
          <a
            data-tooltip-id="tolq-info-top-start"
            data-tooltip-html={t('credit_card.instructions')}
            className="w-8"
          >
            <InfoHollowIcon className="origin-[10px] scale-50 cursor-pointer" />
          </a>
        </div>
        <Button label={t('credit_card.add')} onClick={onClick} size="medium" variant="contained" />
      </Entering>
    );

  return (
    <Entering
      offset={5}
      delay={0.6}
      duration={0.2}
      position="bottom"
      className="flex h-fit w-[37.5%] flex-col justify-between rounded-md bg-white p-4 shadow-custom"
    >
      <Typography variant="medium1" className={'!m-0 !leading-10 text-tertiary-100'}>
        {t('billings.show.credit_card')}
      </Typography>
      <hr className="mb-4 mt-1 border !border-t-0 border-tertiary-600" />

      {state.editing && <CreditCardForm cancel={onCancel} updateCreditCard={onUpdateCreditCard} />}
      {!state.editing && <CreditCardContent onClick={onClick} />}
    </Entering>
  );
};

export default CreditCardMain;
